import { useModal } from '@hooks';
import { FunctionComponent, useEffect } from 'react';
import { ModalState } from '../modal';
import OverviewCard, { OverviewCardProps } from '../overview-card';

export type OverviewCardWithModalProps = {
  overviewCard: Omit<OverviewCardProps, 'onClick'>;
} & {
  modal: {
    content: () => React.ReactNode;
    props?: Partial<ModalState>;
  };
};

const OverviewCardWithModal: FunctionComponent<OverviewCardWithModalProps> = ({
  modal: modalProps,
  overviewCard,
}) => {
  const modal = useModal();

  useEffect(() => {
    if (modalProps.props && modal) {
      modal.updateProps(modalProps.props);
    }
    return () => {
      return;
    };
  }, [modal, modalProps.props]);

  useEffect(() => {
    if (modalProps.content && modal) {
      modal.updateContent(modalProps.content);
    }
    return () => {
      return;
    };
  }, [modal, modalProps.content]);

  function onClick() {
    modal.display(modalProps.content, modalProps.props);
  }
  return <OverviewCard {...overviewCard} onClick={onClick} />;
};

export default OverviewCardWithModal;
